import React from 'react';
import cn from 'classnames';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import AccessRestrictedByIpContext from '@dataroom/access-restricted/contexts/AccessRestrictedByIpContext';
import AccessRestrictedContext from '@dataroom/access-restricted/contexts/AccessRestrictedContext';
import AccessRequestContextProvider, { useAccessRequestContext } from '@dataroom/datarooms/contexts/AccessRequestContext';
import DataroomAccessContextProvider from '@dataroom/datarooms/contexts/DataroomAccessContext';
import ExploreSetsLanding from '@dataroom/datarooms/ui/Set/ExploreSets/ExploreSetsLanding';
import Columns from '@dataroom/datarooms/ui/common/Column';
import LearnMore from '@/dataroom/ui/components/Landing/investorSet/LearnMore';
import LoginModal from './LoginModal';
import FooterPattern from '@framework/ui/Pages/Landing/Sections/FooterPattern';
import titlePattern from '../assets/titlePattern.svg';
import cardStyles from '@dealroadshow/uikit-styles/card.module.scss';
import styles from './exploreSets.module.scss';
import baseStyles from '../tenantInvestorSet.module.scss';

const columns = [
  Columns.Sector,
  Columns.NameNotClickable,
  Columns.Sponsor,
  Columns.Approved,
  Columns.Files,
  Columns.Size,
  Columns.LastActivityExploreSetsWithSessionCheck,
];

const ExploreSets = () => {
  const { tenant } = useDataroomTenantContext();

  const {
    isLoginModalVisible,
    setIsLoginModalVisible,
    dataroom,
    autoSendAction,
  } = useAccessRequestContext();

  const handlePageChange = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const handleLoginModalClose = () => {
    setIsLoginModalVisible(false);
  };

  return (
    <>
      <div className={ cn(baseStyles.intro, styles.intro) }>
        <h1 className={ cn(baseStyles.sectionTitle, baseStyles.title) }>
          Explore Sets
        </h1>
        <div className={ cn(baseStyles.sectionDescription, styles.introDescription, baseStyles.description) }>
          The following transactions are hosted on InvestorSet. To request access: register your free account,
          login and submit the request. If your firm is on the transaction whitelist, access will be granted
          immediately.
        </div>
        <div className={ baseStyles.titlePattern }>
          <img src={ titlePattern.src } />
        </div>
      </div>
      <div className={ styles.exploreSetsContentContainer }>
        <ExploreSetsLanding
          columns={ columns }
          onPageChange={ handlePageChange }
          zeroCaseComponent={ (
            <div className={ cn(styles.zeroCase, cardStyles.cardContainer) }>
              No data
            </div>
          ) }
          isPublicRequest
        />
        { dataroom && (
          <LoginModal
            tenant={ tenant }
            isVisible={ isLoginModalVisible }
            dataroomId={ dataroom.id }
            dataroomName={ dataroom.name! }
            autoSendAction={ autoSendAction! }
            afterClose={ handleLoginModalClose }
            closeOnEsc
            showCloseButton
          />
        ) }
      </div>
      <LearnMore />
      <FooterPattern />
    </>
  );
};

export default () => (
  <AccessRestrictedContext>
    <AccessRestrictedByIpContext>
      <DataroomAccessContextProvider>
        <AccessRequestContextProvider>
          <ExploreSets />
        </AccessRequestContextProvider>
      </DataroomAccessContextProvider>
    </AccessRestrictedByIpContext>
  </AccessRestrictedContext>
);
